module.exports = __webpack_public_path__ + "static/media/copy.91ffa0a7.svg";